export default "__VITE_ASSET__Dtgka9v3__"